import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AlertConfig } from '../alert/alert.dialog';

@Component({
	selector: 'ss-confirm',
	templateUrl: './confirm.dialog.html',
	styleUrls: ['./confirm.dialog.scss'],
	imports: [MatDialogModule, MatButtonModule]
})
export class ConfirmDialog implements OnInit {
	data = inject<AlertConfig>(MAT_DIALOG_DATA);

	defaultConfig: Partial<AlertConfig> = {
		closeLabel: 'No',
		confirmLabel: 'Yes',
		type: 'success',
		reverseButtons: false,
		leftAlign: false
	};

	ngOnInit() {
		this.data = Object.assign(this.defaultConfig, this.data);
	}
}
